import { ConstructionStatus } from "@hshrimal/salesleg";
export const ConstructionStatusDisplayMap = new Map<ConstructionStatus, string>(
  [
    ["ready_to_move_in", "Ready To Move In"],
    ["under_construction", "Under Construction"],
  ]
);
